module.exports = __webpack_public_path__ + "img/9788936508685.a8cd7c4b.jpg";